import { c as _c } from "react/compiler-runtime";
import { createInactivePage } from 'modules/funnels/funnel/api/funnel-api';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import InactiveIcon from 'modules/funnels/funnel/icons/inactive-icon';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
interface InactivePageProps {
  funnelId: FunnelId;
}
function InactivePage(t0) {
  const $ = _c(10);
  const {
    funnelId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    funnel,
    mutateFunnel
  } = useFunnel(funnelId);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== funnel || $[1] !== funnelId || $[2] !== mutateFunnel) {
    t1 = async () => {
      if (funnel) {
        if (funnel.inactivePage) {
          window.location.assign(getPageEditorUrl(funnel.inactivePage.id));
        } else {
          setIsFetching(true);
          const response = await createInactivePage(funnelId);
          const inactivePageId = response.data.inactivePage.id;
          await mutateFunnel(data => {
            if (data) {
              return {
                ...data,
                inactivePage: {
                  id: inactivePageId
                }
              };
            }
          }, false);
          setIsFetching(false);
          window.location.assign(getPageEditorUrl(inactivePageId));
        }
      }
    };
    $[0] = funnel;
    $[1] = funnelId;
    $[2] = mutateFunnel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClickInactivePage = t1;
  let t2;
  if ($[4] !== isFetching || $[5] !== t) {
    t2 = isFetching ? <div className="flex w-full justify-center"><Loader /></div> : <><InactiveIcon className="shrink-0" /><div className="flex flex-col flex-wrap"><span className="text-base font-bold">{t("dashboard.funnel.inactive_page")}</span><span className="text-sm font-normal">{t("dashboard.funnel.inactive_page_description")}</span></div></>;
    $[4] = isFetching;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== handleClickInactivePage || $[8] !== t2) {
    t3 = <li className="hover:bg-brand-primary/[0.06] border-[rgb(var(--text-primary))]/20 flex cursor-pointer gap-3 border-b-[1px] px-[15px] py-[15px] last:border-b-transparent" onClick={handleClickInactivePage}>{t2}</li>;
    $[7] = handleClickInactivePage;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export default InactivePage;